import React from "react";

import ACIconWrapper, { ACIconProps } from "./ACIconWrapper";

export default function ACRestoreIcon(props: ACIconProps) {
  return <ACIconWrapper component={IconSvg} {...props} />;
}

const IconSvg = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.79526 4.23503C10.0797 4.53617 10.0661 5.01085 9.76497 5.29526L6.63642 8.25H15.25C17.8733 8.25 20 10.3767 20 13V19.25C20 19.6642 19.6642 20 19.25 20C18.8358 20 18.5 19.6642 18.5 19.25V13C18.5 11.2051 17.0449 9.75 15.25 9.75H6.63642L9.76497 12.7047C10.0661 12.9892 10.0797 13.4638 9.79526 13.765C9.51085 14.0661 9.03617 14.0797 8.73503 13.7953L4.23503 9.54526C4.08502 9.40358 4 9.20635 4 9C4 8.79366 4.08502 8.59642 4.23503 8.45474L8.73503 4.20474C9.03617 3.92033 9.51085 3.9339 9.79526 4.23503Z"
        fill="currentColor"
      />
    </svg>
  );
};
